import React from 'react';
import { Modal, Fade } from '@honda-canada/design-system-react';
import { useTranslation } from 'react-i18next';
import useConsumerPopup from '../Popup/useConsumerPopup';
import SignupForUpdatesUI from './SignupForUpdatesUI';
var SignupForm = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j;
    var fields = _a.fields, rendering = _a.rendering;
    var t = useTranslation().t;
    var _k = useConsumerPopup(rendering), isCurrentPopup = _k.isCurrentPopup, setPopupId = _k.setPopupId;
    var closeModal = function () { return setPopupId(null); };
    if (!fields) {
        return null;
    }
    var title = (_b = fields === null || fields === void 0 ? void 0 : fields.title) === null || _b === void 0 ? void 0 : _b.value;
    var body = (_c = fields === null || fields === void 0 ? void 0 : fields.bodyText) === null || _c === void 0 ? void 0 : _c.value;
    var legalDisclaimer = (_d = fields === null || fields === void 0 ? void 0 : fields.legalDisclaimer) === null || _d === void 0 ? void 0 : _d.value;
    var formName = (_e = fields === null || fields === void 0 ? void 0 : fields.formName) === null || _e === void 0 ? void 0 : _e.value;
    var pageUrl = (_f = fields === null || fields === void 0 ? void 0 : fields.pageUrl) === null || _f === void 0 ? void 0 : _f.value;
    var ctaLink = (_g = fields === null || fields === void 0 ? void 0 : fields.ctaLink) === null || _g === void 0 ? void 0 : _g.value;
    var ctaType = ((_h = fields === null || fields === void 0 ? void 0 : fields.ctaType) === null || _h === void 0 ? void 0 : _h.value) || 'Primary';
    var ctaButton = {
        styling: (_j = ctaType.toLowerCase) === null || _j === void 0 ? void 0 : _j.call(ctaType),
        ctaLink: ctaLink,
    };
    return (React.createElement(Modal, { isOpen: isCurrentPopup(), styling: "default", closeAriaLabel: t('Shared.Common.pressToClosePopupAria'), iconSize: "default", "data-testid": "cy-signup-for-updates", padding: "0px" }, function () { return (React.createElement(Fade, { shouldAnimate: true, initialOpacity: 0 },
        React.createElement(SignupForUpdatesUI, { closeModal: closeModal, title: title, body: body, legalDisclaimer: legalDisclaimer, formName: formName, pageUrl: pageUrl, ctaButton: ctaButton }))); }));
};
export default SignupForm;
